import Icon from '../components/Icon.vue'

Icon.register({"sign":{"width":512,"height":512,"paths":[{"d":"M496 64H128V16C128 7.2 120.8 0 112 0H80C71.2 0 64 7.2 64 16V64H16C7.2 64 0 71.2 0 80V112C0 120.8 7.2 128 16 128H64V496C64 504.8 71.2 512 80 512H112C120.8 512 128 504.8 128 496V128H496C504.8 128 512 120.8 512 112V80C512 71.2 504.8 64 496 64zM160 384H480V160H160V384z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/sign.js
// module id = null
// module chunks = 